"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_paginate_1 = __importDefault(require("react-paginate"));
var hooks_1 = require("../../../hooks");
var Pagination = function (_a) {
    var withPageJump = _a.withPageJump, page = _a.page, totalPages = _a.totalPages, handlePageChange = _a.handlePageChange;
    var _b = react_1.useState(page + 1), displayPage = _b[0], setDisplayPage = _b[1];
    var inputRef = react_1.useRef(null);
    var handleClickOutside = react_1.useCallback(function () {
        if (isNaN(displayPage) || typeof displayPage !== "number") {
            setDisplayPage(displayPage + 1);
        }
    }, [displayPage]);
    hooks_1.useClickOutside(inputRef, handleClickOutside);
    var handleInputChange = react_1.useCallback(function (_a) {
        var value = _a.target.value;
        var intVal = parseInt(value, 10);
        setDisplayPage(isNaN(intVal) ? value : intVal);
    }, [setDisplayPage]);
    var handleSubmitPage = react_1.useCallback(function () {
        if (typeof displayPage !== "number" || isNaN(displayPage))
            return;
        var toPage = displayPage - 1;
        if (displayPage > totalPages) {
            setDisplayPage(totalPages);
            toPage = totalPages - 1;
        }
        handlePageChange({ selected: toPage });
    }, [displayPage, setDisplayPage, handlePageChange]);
    var handleSubmitWithEnter = react_1.useCallback(function (_a) {
        var key = _a.key;
        key === "Enter" && handleSubmitPage();
    }, [handleSubmitPage]);
    hooks_1.useRefListener(inputRef, 'keydown', handleSubmitWithEnter);
    return (react_1.default.createElement("div", { className: "pagination" },
        withPageJump && (react_1.default.createElement("div", { className: "pagination__jump" },
            react_1.default.createElement("div", { className: "pagination__jump_message" }, "Go To Page:"),
            react_1.default.createElement("input", { type: "number", ref: inputRef, min: "1", max: totalPages || 0, onChange: handleInputChange, value: displayPage }),
            react_1.default.createElement("button", { className: "pagination__jump__go", onClick: handleSubmitPage }, "Go"))),
        react_1.default.createElement(react_paginate_1.default, { nextLabel: react_1.default.createElement("i", { className: "pagination__left fas fa-caret-right", style: { fontSize: "1.25em" } }), previousLabel: react_1.default.createElement("i", { className: "pagination__right fas fa-caret-left", style: { fontSize: "1.25em" } }), forcePage: page, pageCount: totalPages, marginPagesDisplayed: 1, pageRangeDisplayed: 2, onPageChange: handlePageChange, containerClassName: "pagination__react-paginate", activeClassName: "active" })));
};
exports.default = Pagination;
